import {Component, EventEmitter, Input, OnDestroy, OnInit, Output} from "@angular/core";
import {finalize} from 'rxjs/operators';
import {PrintMenuService} from "../../../../core/services/gestionmenus/print-menu.service";
import {
  PreparationConditionnementService
} from "../../../../core/services/conditionnements/preparation-conditionnement.service";
import {BON_ALLOT_GROUPING_ORDER_LABELS, BonAllotGroupingOrder} from "../../../../core/enums/bon-allotissement-grouping-enum";
import {BonAllotissementSortingEnum} from "../../../../core/enums/bon-allotissement-sorting-enum";
import BonAllotissementSettingsMl from "../../../../core/dtos/conditionnement/bon-allotissement-settings-ml";
import {ButtonThemeEnum} from '../../../../shared/ui/button/button-theme-enum';

@Component({
    selector: 'yo-bon-allotissement',
    templateUrl: './bon-allotissement.component.html',
    styleUrls: ['./bon-allotissement.component.scss'],
    standalone: false
})

export class BonAllotissementComponent implements OnInit, OnDestroy {

  public readonly ButtonThemeEnum = ButtonThemeEnum;


  @Input() public idPlanProduction: number;
  @Input() public idPlanProductionDetails: number[];
  @Output() loadingChange = new EventEmitter<{ visible: boolean; message: string }>();
  displayDialog: boolean = false;
  grouping: BonAllotGroupingOrder = BonAllotGroupingOrder.TOURNEE_PLAT_PLC;
  dontDisplayMeal: boolean = false;
  displayVariante: boolean = false;
  sorting: BonAllotissementSortingEnum = BonAllotissementSortingEnum.DATE_LIVRAISON;
  formatPrintingOptions: any[] = Object.values(BonAllotGroupingOrder)
    .map(value => ({ label: BON_ALLOT_GROUPING_ORDER_LABELS[value], value }));
  sortPrintingOptions: any[] = [{ label: 'Date de livraison', value: BonAllotissementSortingEnum.DATE_LIVRAISON }, { label: 'Date de fabrication', value: BonAllotissementSortingEnum.DATE_FABRICATION }];

  totalAndTraca: boolean = false;

  constructor(
    private printMenuService: PrintMenuService,
    private pcSvc: PreparationConditionnementService) {
  }

  ngOnInit(): void {
    this.printMenuService.displayDialogPrintBonAllotissement$.subscribe(() => {
      this.displayDialog = true;
      this.grouping = BonAllotGroupingOrder.TOURNEE_PLAT_PLC;
      this.totalAndTraca = false;
      this.dontDisplayMeal = false;
      this.displayVariante = false;
    });
  }

  ngOnDestroy(): void {
    this.displayDialog = false;
  }

  downloadBonAllotissement = (): void => {
    const settings: BonAllotissementSettingsMl = new BonAllotissementSettingsMl();
    settings.idPlanProduction = this.idPlanProduction;
    settings.grouping = this.grouping;
    settings.force = false;
    settings.totalTraca = this.totalAndTraca;
    settings.sortingDate = this.sorting;
    settings.planProductionDetailsList = this.idPlanProductionDetails;
    settings.displayMeal = !this.dontDisplayMeal;
    settings.displayVariante = this.displayVariante;
    this.displayDialog = false;
    this.loadingChange.emit({ visible: true, message: 'Impression en cours...' });
    this.pcSvc.printBonAllotissement(settings)
      .pipe(finalize(() => this.loadingChange.emit({ visible: false, message: '' })))
      .subscribe();
  };

  closeDialog = () => {
    this.displayDialog = false;
    this.grouping = BonAllotGroupingOrder.TOURNEE_PLAT_PLC;
    this.sorting = BonAllotissementSortingEnum.DATE_LIVRAISON;
  }
}
